import { FC } from "react";
import { useAppStore } from "@/store";
import { SettingsTabId } from "@/store/pages/SettingsPageStore";
import { observer } from "mobx-react-lite";
import { NoUpcomingMeetingsContentView } from "./no-upcoming-meetings-content.view";

interface NoUpcomingMeetingsContentProps {
  cutoffDayName: string;
  connectedCalendarsCount: number;
}

export const NoUpcomingMeetingsContent: FC<NoUpcomingMeetingsContentProps> = observer(
  ({ cutoffDayName, connectedCalendarsCount }) => {
    const { store } = useAppStore();

    const handleClick = () => {
      store.settingsModal.open(SettingsTabId.CalendarAndMeetingsPage);
    };

    return (
      <NoUpcomingMeetingsContentView
        cutoffDayName={cutoffDayName}
        connectedCalendarsCount={connectedCalendarsCount}
        onClick={handleClick}
      />
    );
  }
);
